import { render, staticRenderFns } from "./RuminateDetail.vue?vue&type=template&id=8bd6a36e&scoped=true"
import script from "./RuminateDetail.vue?vue&type=script&lang=js"
export * from "./RuminateDetail.vue?vue&type=script&lang=js"
import style0 from "./RuminateDetail.vue?vue&type=style&index=0&id=8bd6a36e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd6a36e",
  null
  
)

export default component.exports